import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from 'src/app/App.state';
import { DashBoardEstadoFaturamento } from 'src/app/base/domain/dashboard-estado-faturamento.model';
import { DashBoardFaturamento } from 'src/app/base/domain/dashboard-faturamento';
import { DashBoardFaturamentoService } from 'src/app/base/services/dashboard-faturamento.service';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { DashBoardFilterOptions } from 'src/app/global/faturamento-dashboard/faturamento-dashboard.component';

@Component({
  selector: 'app-acompanhamento-faturamento-main',
  templateUrl: './acompanhamento-faturamento-main.component.html',
  styleUrls: ['./acompanhamento-faturamento-main.component.css'],
})
export class AcompanhamentoFaturamentoMainComponent implements OnInit {
  dashboard: DashBoardFaturamento = new DashBoardFaturamento();

  data = new Date();
  dashboardEstadoList: DashBoardEstadoFaturamento[] = [];

  queryOptions = new QueryOptions({ pageSize: 10 });

  constructor(private service: DashBoardFaturamentoService, private router: Router, public appState: AppState) { }

  ngOnInit(): void {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    this.data = date;
    this.queryOptions.params = {
      dataInicial: date.getTime(),
      dataFinal: date.getTime(),
    };

    this.getDashBoard();
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  onReload(): void {
    this.getDashBoard();
  }

  getDashBoard(): void {
    this.data.setHours(0, 0, 0, 0);
    this.appState.isLoading = true;
    this.service.getDashBoard(this.queryOptions).subscribe((response: DashBoardFaturamento) => {
      this.getDashBoardEstado();
      this.dashboard = response;
    });
  }

  getDashBoardEstado(): void {
    this.service.getDashboardEstadoFaturamento().subscribe((response: DashBoardEstadoFaturamento[]) => {
      this.dashboardEstadoList = response;
      this.appState.isLoading = false;
    });
  }

  onDisclosure(dashboard: DashBoardEstadoFaturamento): void {
    this.queryOptions.params = {
      ...this.queryOptions.params,
      nomeEstado: dashboard.nomeEstado ? dashboard.nomeEstado : null,
    };

    this.router.navigate(['base/gestao/faturamento/acompanhamento-estado-faturamento/' + dashboard.estadoId], {
      queryParams: this.queryOptions.params,
    });
  }

  onFilter(options: DashBoardFilterOptions): void {
    this.queryOptions.params = {
      postoId: options.postoSelecionado ? options.postoSelecionado.id : null,
      estadoId: options.estadoSelecionado ? options.estadoSelecionado.id : null,
      dataInicial: options.dataInicial ? options.dataInicial.getTime() : null,
      dataFinal: options.dataFinal ? options.dataFinal.getTime() : null,
    };

    this.getDashBoard();
  }
}
